// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9c2a8d82","57":"d161e3aa","172":"f6635153","320":"516803f3","344":"48ff2d9a","355":"f54cfb35","395":"a54bfabc","509":"e8ddadf2","552":"32ca8e37","727":"5cd20c63","864":"e22649e7","948":"4328e354","990":"ef64085c"}[chunkId] + ".chunk.js";
};